/* Kilux motion + live data: reveal on scroll (reduced-motion aware), delivery cutoff countdown, header glass state. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Reveal
  var targets = '.kx-card, .kx-tile, .kx-dept, .kx-pdp__block, .kx-mini, .kx-head, .kx-kits__copy, .kx-bom, .kx-help__in, .kx-404__cat';
  function arm() {
    var els = document.querySelectorAll(targets + ':not([data-kx-r])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.setAttribute('data-kx-r', 'in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.setAttribute('data-kx-r', 'in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e, i) { e.setAttribute('data-kx-r', ''); e.style.setProperty('--kx-d', (i % 8) * 45 + 'ms'); io.observe(e); });
  }
  arm(); document.addEventListener('shopify:section:load', arm);
  // Cutoff countdown (Mexico City, Mon-Fri 13:00)
  function mx() { var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Mexico_City', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date()); var o = {}; p.forEach(function (x) { o[x.type] = x.value; }); return { wd: o.weekday, h: +o.hour % 24, m: +o.minute }; }
  function tick() {
    var els = document.querySelectorAll('[data-kx-cutoff]'); if (!els.length) return;
    var t = mx(), cutoff = 13, weekend = t.wd === 'Sat' || t.wd === 'Sun', mins = cutoff * 60 - (t.h * 60 + t.m), txt, state;
    if (!weekend && mins > 0) { var h = Math.floor(mins / 60), m = mins % 60; txt = 'Pide en ' + (h ? h + ' h ' : '') + m + ' min y recibe hoy en CDMX'; state = 'today'; }
    else if (!weekend && t.h < 20) { txt = 'Pide hoy y recibe mañana en CDMX, Edomex y Querétaro'; state = 'tomorrow'; }
    else { txt = 'Pide ahora y recibe el próximo día hábil'; state = 'next'; }
    els.forEach(function (e) { e.textContent = txt; e.setAttribute('data-state', state); });
  }
  tick(); setInterval(tick, 30000);
})();
